import React from 'react';
import { FaTimes } from 'react-icons/fa';

interface ImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  title: string;
}

const ImageModal: React.FC<ImageModalProps> = ({ isOpen, onClose, imageUrl, title }) => {
  if (!isOpen) return null;

  // Validar que la URL sea válida
  const isValidUrl = imageUrl && (imageUrl.startsWith('http') || imageUrl.startsWith('https'));
  
  // Detectar si es un PDF
  const isPdf = imageUrl && (imageUrl.includes('.pdf') || imageUrl.includes('application/pdf'));

  return (
    <div className="fixed inset-0 bg-black/80 flex justify-center items-center z-[9999] animate-fadeIn">
      <div className="relative max-w-[90vw] max-h-[90vh] bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Header con título y botón de cerrar */}
        <div className="flex justify-between items-center p-4 bg-gray-50 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
          <button 
            onClick={onClose}
            className="bg-white/70 border border-red-200 text-red-500 hover:bg-red-500 hover:text-white cursor-pointer p-2 flex items-center justify-center rounded-full shadow-lg transition-all duration-300 text-xl"
          >
            <FaTimes/>
          </button>
        </div>
        
                    {/* Contenido de la imagen */}
            <div className="p-4">
              {!isValidUrl ? (
                <div className="flex items-center justify-center h-64 bg-gray-100 rounded-lg">
                  <div className="text-center text-gray-500">
                    <div className="text-4xl mb-2">📋</div>
                    <div className="text-lg font-semibold">Información de Certificación</div>
                    <div className="text-sm">Esta certificación no tiene archivos adjuntos</div>
                    {imageUrl && (
                      <div className="text-xs mt-2 text-gray-400">URL: {imageUrl}</div>
                    )}
                  </div>
                </div>
              ) : isPdf ? (
                <div className="flex flex-col items-center justify-center h-64 bg-gray-100 rounded-lg">
                  <div className="text-center text-gray-500 mb-4">
                    <div className="text-6xl mb-4">📄</div>
                    <div className="text-lg font-semibold">Documento PDF</div>
                    <div className="text-sm mb-4">Este es un archivo PDF que no se puede previsualizar</div>
                  </div>
                  <div className="flex gap-3">
                    <a 
                      href={imageUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors"
                    >
                      Abrir PDF
                    </a>
                    <a 
                      href={imageUrl} 
                      download
                      className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors"
                    >
                      Descargar
                    </a>
                  </div>
                </div>
              ) : (
                <img 
                  src={imageUrl} 
                  alt={title}
                  className="max-w-full max-h-[70vh] object-contain rounded-lg shadow-lg"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    console.error('Error loading image:', imageUrl);
                    target.style.display = 'none';
                    // Mostrar mensaje de error en lugar de intentar cargar placeholder
                    const errorDiv = document.createElement('div');
                    errorDiv.className = 'flex items-center justify-center h-64 bg-gray-100 rounded-lg';
                    errorDiv.innerHTML = `
                      <div class="text-center text-gray-500">
                        <div class="text-4xl mb-2">📄</div>
                        <div class="text-lg font-semibold">No se pudo cargar la imagen</div>
                        <div class="text-sm">URL: ${imageUrl}</div>
                      </div>
                    `;
                    target.parentNode?.appendChild(errorDiv);
                  }}
                />
              )}
            </div>
      </div>
    </div>
  );
};

export default ImageModal; 